import React, { useState } from 'react'
import MainButton from 'components/commons/MainButton'
import SecondaryButton from 'components/form/SecondaryButton'
import logoZonaSer from 'images/zona ser.png'
import { useStateValue } from 'context/store'
import { makeStyles, Dialog, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   dialogContainer: {
      width: 443,
      height: 225,
      borderTop: '4px solid #3264DC'
   },
   content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
   },
   logo: {
      marginTop: theme.spacing(5.5)
   },
   text: {
      marginTop: theme.spacing(2.5)
   },
   buttonsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(0, 4.5, 3),
      marginTop: theme.spacing(2)
   }
}))

function WelcomeTourModal() {
   const classes = useStyles()

   const [_, dispatch] = useStateValue()

   const [openModal, setOpenModal] = useState(true)

   function handleCloseModal() {
      setOpenModal(false)
      dispatch({ type: 'CLOSE_MENU_DRAWER' })
      dispatch({ type: 'DONT_ASK_WELCOME_TOUR' })
   }

   function startTour() {
      setOpenModal(false)
      dispatch({ type: 'PLAY_WELCOME_TOUR' })
      dispatch({ type: 'DONT_ASK_WELCOME_TOUR' })
   }

   return (
      <Dialog open={openModal}>
         <div className={classes.dialogContainer}>
            <div className={classes.content}>
               <img
                  src={logoZonaSer}
                  height="30px"
                  alt={'Logo Zona Ser'}
                  className={classes.logo}
               />
               <Typography className={classes.text}>
                  Bienvenidos al Portal ZonaSer
               </Typography>
            </div>
            <div className={classes.buttonsContainer}>
               <div>
                  <SecondaryButton
                     text="OMITIR RECORRIDO"
                     onClick={handleCloseModal}
                  />
               </div>
               <div>
                  <MainButton text="INICIAR RECORRIDO" onClick={startTour} />
               </div>
            </div>
         </div>
      </Dialog>
   )
}

export default WelcomeTourModal
